export enum WizardStep {
  Confirm = 0,
  Update = 1,
  Validate = 2,
  Deliver = 3,
}
